import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { map } from 'rxjs/operators';

import { serverOCD } from '../constants';
import { Code } from './models/code.model';
import { Currency } from './models/currency.model';
import { MemberLevel } from './models/member-level.model';
import { State } from './models/state.model';
import { Option } from './models/option.model';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {

  private apiURL: string;

  // array of stateSource
  private stateSources = [];
  public states$ = [];

  private secondCurrencyRequired: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private http: HttpClient,
    private handler: HttpBackend,
  ) {
    this.http = new HttpClient(this.handler);
    this.apiURL = serverOCD + '/api/v1/';
  }

  getAllCodes(codeName: string): Observable<Option[]> {
    return this.transformToOptions(this.http.get<Code[]>(this.apiURL + codeName), 'longDescription', 'code');
  }

  // type could be 'payment' or 'secondary'
  getAllCurrencies(type: string): Observable<Option[]> {
    return this.transformToOptions(this.http.get<Currency[]>(this.apiURL + 'currency/' + type), 'description', 'code');
  }

  getAllMemberLevels(): Observable<Option[]> {
    return this.transformToOptions(this.http.get<MemberLevel[]>(this.apiURL + 'paylocmemberlevel'), 'type', 'value');
  }

  getStatesByCountryCode(countryCode: string): Observable<Option[]> {
    return this.transformToOptions(this.http.get<State[]>(this.apiURL + 'country/' + countryCode + '/state'), 'name', 'stateCode');
  }

  transformToOptions(list: Observable<any[]>, key: string, value: string): Observable<Option[]> {
    return list.pipe<Option[]>(map<any[], Option[]>(items => {
      const options: Option[] = [];
      items.forEach(item => {
        const option = new Option(item[key], item[value]);
        if (item.payMethod) {
          option.payMethod = item.payMethod;
        }
        options.push(option);
      });
      return options;
    }));
  }

  populateStates(countryCode: string, controlName: string) {
    this.stateSources[controlName].next(this.getStatesByCountryCode(countryCode));
  }

  isSecondCurrencyRequired(): boolean {
    return this.secondCurrencyRequired.getValue();
  }

  checkPayMethod(payMethod: Code) {
    let isWire = false;
    if (payMethod.code === '3') {
      isWire = true;
    }
    this.secondCurrencyRequired.next(isWire);
  }

  initStateSource(countryDropdown: string) {
    this.stateSources[countryDropdown] = new Subject<Observable<State[]>>();
    this.states$[countryDropdown] = this.stateSources[countryDropdown].asObservable();
  }

  public getCountry(key: string): Observable<Code> {
    let code: Code = new Code();
    code.code = key;
    return this.http.post<Code>(this.apiURL + 'country/detail', code);
  }

}
